<template>
    <div id="sign-in">
        <div class="logo-box">
            <img class="logo" src="@/assets/fixed-invitation/logo.png" alt="">
        </div>
        <div class="title-box">
            <p>注册金果子</p>
        </div>
        <div class="switch-type"><span @click="switchResType">{{ phoneRegist ? '邮箱注册' : '手机注册' }}</span></div>
        <div class="form-box">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                <el-form-item prop="phone">
                    <div class="input-box">
                        <i :class="phoneRegist ? 'el-icon-mobile-phone' : 'el-icon-message'" class="left" />
                        <code-select v-if="phoneRegist" :area-list="areaList" class="left" @code-change="codeChange" />
                        <el-input 
                            v-model="ruleForm.phone" 
                            ref="phone" 
                            type="text" size="medium" 
                            class="value-input left"  
                            :class="phoneRegist ? 'username-input' : 'mail-input'"
                            :placeholder="phoneRegist ? '请输入手机号' : '请输入邮箱地址'" 
                            autocomplete="on" 
                            clearable 
                        />
                    </div>
                </el-form-item>

                <el-form-item prop="password">
                    <div class="input-box password">
                        <el-input v-model="ruleForm.password" name="password" :type="eyeOpen ? 'text' : 'password'" class="value-input password-input" size="medium" placeholder="请设置密码" prefix-icon="el-icon-lock" autocomplete="on" clearable />
                        <span class="eye" @click="eyeOpen = !eyeOpen">
                            <img v-if="!eyeOpen" src="@/assets/fixed-invitation/eye.png" alt="">
                            <img v-else src="@/assets/fixed-invitation/eye-o.png" alt="">
                        </span>
                    </div>
                </el-form-item>

                <el-form-item>
                    <div class="input-box invite-code">
                        <div class="code">
                            <span name="code">邀请注册码:{{ruleForm.registCode}}</span>
                            <span name="code">推荐人邀请码:{{ruleForm.inviteCode}}</span>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <div class="protocal-box">
            <el-checkbox class="check-input" v-model="checked"></el-checkbox>
            <span class="protocal">
                我已阅读并同意JGZ<a :href="`https://misc.jgzpro.com/protocol/?language=${language}`" target="_blank" rel="noopener noreferrer">《用户协议》和</a><a :href="`https://misc.jgzpro.com/policy/?language=${language}`" target="_blank" rel="noopener noreferrer">《隐私条款》</a>
            </span>
            <!-- https://sanrenxing.pro/protocol/ -->
        </div>
        <div class="sign-in-btn" :class="checked ? 'active' : ''" @click="goInputCode">注册</div>
        <div class='login-line'>已注册？<span class="login-btn" @click="goDown">登录</span></div>
        <!-- <div class="down-logo">
            <img src="@/assets/srx/sign/login-logo.png" alt="">
            <div class="sign-in-btn down" @click="goDown">去下载</div>
        </div> -->
        <div class="alert" v-show="alertShow">
            <span>{{message}}</span>
        </div>
        <img class="corner" src="@/assets/fixed-invitation/corner.png" alt="">
    </div>
</template>

<script>
import CodeSelect from '@/components/CodeSelect'
import { isNum, validPassword, validEmail } from '@/utils/validate'
const Base64 = require('js-base64').Base64
export default {
    name: 'SignIn',
    components: { CodeSelect },
    data() {
        const self = this
        const validateUsername = (rule, value, callback) => {
            // debugger
            if (self.phoneRegist && !isNum(value)) {
                    callback(new Error('手机号码输入有误，请重新填写。'))
            } else if (!self.phoneRegist &&  !validEmail(value)) {
                callback(new Error('邮箱格式有误，请重新填写。'))
            } else {
                let params = self.phoneRegist ? { mobile: self.area + value } : { email: value }
                self.$MyAxios.get(`/api/accounts/${self.phoneRegist ? 'mobile' : 'email'}/isAvailable`, {
                    params: params
                }, 
                response => {
                    if(response.code === 1) {
                        if(response.data) {
                            callback()
                        }else {
                            callback(new Error('该用户已存在')) 
                        }
                    }
                }, error => {

                })
            } 
        }
        const validatePass = (rule, value, callback) => {
            if (!validPassword(value)) {
                callback(new Error('要同时含有数字和字母，长度要在8-16位之间'))
            } else {
                callback()
            }
        }
        return {
            phoneRegist: false,
            areaList: [],
            area: '852',
            eyeOpen: false,
            alertShow: false,
            message: '',
            ruleForm: {
                phone: '',
                password: '',
                inviteCode: '',
                registCode: ''
            },
            rules: {
                phone: [{ required: true, validator: validateUsername, trigger: 'blur' }],
                password: [{ required: true, validator: validatePass, trigger: 'change' }]
            },
            inviteCode: '',
            registCode: '',
            infoCode: '',
            checked: false,
            language: ''
        }
    },
    mounted() {
        if(this.$i18n.locale === 'zh') {
            this.language = 'CHINESE'
        } else if (this.$i18n.locale === 'zh-h'){
            this.language = 'CHINESETRAD'
        } else {
            this.language = 'ENGLISH'
        }
        let data = this.$route.query.d
        if(data) {
            this.infoCode = Base64.decode(data).split('_')[1];
        }
        this.ruleForm.inviteCode = this.$route.query.inviteCode ? this.$route.query.inviteCode : this.infoCode
        this.ruleForm.registCode = this.$route.query.registCode ? this.$route.query.registCode : this.registCode
        this.getAreaList()
        // alert(this.ruleForm.inviteCode)
        // this.$nextTick(() => {
        //     let data = this.$route.query.d
        //     if(data) {
        //         this.infoCode = Base64.decode(data).split('_')[1];
        //     }
        //     this.ruleForm.inviteCode = this.$route.query.inviteCode ? this.$route.query.inviteCode : this.infoCode
        // })
        // window.onpageshow = () => {
        //     // alert(this.ruleForm.inviteCode)
        //     setTimeout(() => {
        //         let data = this.$route.query.d
        //         if(data) {
        //             this.infoCode = Base64.decode(data).split('_')[1];
        //         }
        //         this.ruleForm.inviteCode = this.$route.query.inviteCode ? this.$route.query.inviteCode : this.infoCode
        //     }, 2000);
        // }
    },
    methods: {
        switchResType() {
            this.phoneRegist = !this.phoneRegist; 
            this.ruleForm.phone = ''; 
            this.$refs['ruleForm'].resetFields()
        },
        getAreaList() {
            this.$MyAxios.get(`/api/accounts/locations`, {}, 
            response => {
                if(response.code === 1) {
                    this.showLoading = false;
                    const data = response.data
                    this.areaList = data
                }
            }, error => {
                this.showLoading = false;
            })
        },
        codeChange(code) {
            this.area = code
        },
        goInputCode() {
            if(!this.ruleForm.inviteCode || !this.ruleForm.registCode) {
                this.message = '邀请码、注册码不能为空'
                this.alertShow = true
                setTimeout(() => {
                    this.alertShow = false
                }, 2000);
                return
            }
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    if(this.checked) {
                        this.$router.push({ name: 'FixedInvitationCode', params: { form: this.ruleForm, area: this.area, tag: this.phoneRegist }})
                    }else{
                        this.alertShow = true
                        this.message = '请勾选用户协议'
                        setTimeout(() => {
                            this.alertShow = false
                        }, 2000);
                    }
                }
            })
        },
        goDown() {
            window.open(window.location.protocol + "//" + window.location.host)
        }
    }
}
</script>

<style lang='less'>
#sign-in {
    height: 100vh;
    width: 100%;
    background: #ffffff;
    padding: 88px 30px 0 30px;
    .logo-box {
        margin-bottom: 6px;
        .logo {
            width: 136px;
            height: 136px;
        }
    }
    .title-box {
        margin: 0 auto;
        margin-bottom: 80px;
        line-height: 93px;
        p {
            margin: 0 auto;
            line-height: 70px;
            font-size: 50px;
            color: #33333a;
            font-weight: bold;
            &.blue {
                color: #4F71F9;
            }
        }
    }
    .switch-type {
        line-height: 40px;
        margin-bottom: 20px;
        text-align: right;
        font-size: 28px;
    }
    .form-box {
        margin-bottom: 90px;
        .el-form-item {
            margin-bottom: 50px;
            .el-form-item__error {
                font-size: 28px;
            }
        }
        .input-box {
            height: 100px;
            margin-bottom: 0px;
            border-bottom: 1px solid #EBECF0;
            .el-icon-mobile-phone, .el-icon-message {
                height: 100px;
                line-height: 100px;
                width: 40px;
                text-align: center;
                color: #33333a;
                font-weight: bold;
                margin-right: 10px;
                padding-left: 15px;
                font-size: 38px;
                vertical-align: middle;
            }
            &.password {
                position: relative;
                .el-input__suffix {
                    right: 70px;
                }
                .el-input__icon {
                    color: #33333a;
                    font-weight: bold;
                }
                .eye {
                    display: inline-block;
                    position: absolute;
                    height: 34px;
                    width: 34px;
                    top: 33px;
                    right: 4px;
                    img {
                        height: 34px;
                        width: 34px;
                    }
                }
            }
        }
        .el-input {
            height: 100px;
            font-size: 40px;
            .el-input__inner {
                height: 100px;
                padding: 0 60px;
                border: none;
                &::-webkit-input-placeholder {
                    font-size: 30px;
                }
            }
            .el-input__prefix {
                width: 40px;
                .el-input__icon:before {
                    line-height: 100px;
                    width: 40px;
                }
            }
            .el-input__suffix {
                width: 40px;
                .el-input__icon:before {
                    line-height: 100px;
                    width: 40px;
                    font-size: 40px;
                }
            }
            &.is-disabled .el-input__inner {
                color: #9598A6;
                background-color: #F8F9FB;
            }
        }
        .code-select .area-list-box.show .el-input .el-input__inner {
            padding: 0 10px;
            font-size: 34px;
        }
        .username-input {
            width: 505px;
            margin-top: -1px;
            .el-input__inner { 
                padding: 0 10px;
            }
        }
        .mail-input {
            width: 640px;
            margin-top: -1px;
            .el-input__inner { 
                padding: 0 10px;
            }
        }
        .password-input {
            margin-top: -1px;
        }
        .invite-code {
            text-align: center;
            background: #F2F3F5;
            height: 56px;
            .code {
                display: inline-block;
                color: #9598A6;
                line-height: 56px;
                font-size: 28px;
                color: #9598A6;
                margin-left: 10px;
                vertical-align: middle;
                span {
                    margin-right: 10px;
                }
            }
        }
    }
    .protocal-box {
        text-align: center;
        margin-bottom: 30px;
    }
    .check-input {
        width: 32px;
        height: 32px;
        margin-right: 5px;
        vertical-align: middle;
        .el-checkbox__inner {
            width: 32px;
            height: 32px;
            &:after {
                height: 16px;
                width: 10px;
                left: 6px;
            }
        }
        .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
            background-color: #FFA41F;
            border-color: #FFA41F;
        }
    }
    .protocal {
        font-size: 20px;
        line-height: 32px;
        color: #818499;
        vertical-align: middle;
        a {
            color: #FFA41F;
        }
    }
    .sign-in-btn {
        width: 690px;
        height: 88px;
        border-radius: 8px;
        color: #9598A6;
        background: #F2F3F5;
        text-align: center;
        font-size: 34px;
        line-height: 88px;
        margin-bottom: 30px;
        &.active {
            background: #FFA41F;
            color: #ffffff;
        }
    }
    .login-line {
        color: #9598A6;
    }
    .login-btn {
        color: #FFA41F;
    }
    .down-logo {
        height: 120px;
        width: 100vw;
        position: fixed;
        bottom: 0;
        left: 0;
        text-align: left;
        padding: 10px 30px;
        border-top: 1px solid #EBECF0;
        img {
          width: 300px;
          height: 100px;  
          vertical-align: middle;
          margin-right: 180px;
        }
        .down {
            width: 200px;
            display: inline-block;
            vertical-align: middle;
            margin: 0;
        }
    }
    .corner {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 340px;
        height: 340px;
    }
    .alert {
        position: fixed;
        z-index: 3;
        top: 40%;
        left: 50%;
        height: 60px;
        width: auto;
        padding: 0 30px;
        transform: translateX(-50%);
        border-radius: 8px;
        background: rgba(0, 0, 0, .9);
        color: #ffffff;
        line-height: 60px;
    }
}
</style>